import React from 'react';
import styles from './TemplateMain.module.css';
import ProductTypes from '../ProductTypes/ProductTypes';
import TemplateBubbles from '../TemplateBubbles/TemplateBubbles';
import ProductTypeEditor from '../ProductTypeEditor/ProductTypeEditor';
import { useSelector } from 'react-redux';
import { useProductTypesLogic } from '../ProductTypes/hooks/useProductTypesLogic';
import { Button, Dialog } from '@mui/material';
import MethodChooser from '../MethodChooser/MethodChooser';
import { useTranslation } from 'react-i18next';

const TemplateMain = ({ isTemplate, setIsTemplate, templates, modifiers }) => {
  const { t } = useTranslation();
  const {
    selectedEdit,
    isEdit,
    datagridData,
    handleProductTypeSelect,
    handleAddNew,
    resetForm,
    handleDialogSubmit,
    handleDialogClose,
    dialogOpen,
    setDialogOpen,
    handleSubmit,
    deleteModifier,
    createPrio2Modifier,
    createModifier,
    updateModifier,
    updatePrio2Modifier,
    prio2Edit,
    setPrio2Edit,
    setSelectedEdit,
    setIsEdit,
    prio2Modifiers,
    handleAddNewDialog,
    handleCloseNewDialog,
    isDialog,
    selectedMethod,
    changeMethod,
    shopId,
    navigate
  } = useProductTypesLogic(modifiers);

  const shopTier = useSelector((state) => state.nonPersistedReducers?.shopTierSliceReducer?.shopTier);

  return !isEdit && !isTemplate ? (
    <div className={styles.mainPart}>
      <ProductTypes
        handleProductTypeSelect={handleProductTypeSelect}
        handleAddNewDialog={handleAddNewDialog}
        currentModifiers={modifiers?.data}
      />
      {shopTier?.pricingTemplates ? (
        <TemplateBubbles setIsTemplate={setIsTemplate} templates={templates} />
      ) : (
        <div className={styles.overlayContainer}>
          <div className={styles.overlay}>
            <div className={styles.overlayText}>{t('templates.overlayText')}</div>
            <button
              className={styles.button}
              onClick={() => navigate(`/shops/${shopId}/administration/subscriptions-bundles`)}>
              {t('templates.overlayButtonText')}
            </button>
          </div>
          <div className={styles.content}>
            <TemplateBubbles setIsTemplate={setIsTemplate} isOverlayed={true} />
          </div>
        </div>
      )}
      <Dialog open={isDialog} onClose={handleCloseNewDialog}>
        <div className={styles.dialogMain}>
          <h2>{t('templates.dialogTitle')}</h2>
          <MethodChooser
            selectedMethod={selectedMethod}
            onMethodChange={(answer) => {
              changeMethod(answer);
            }}
            shopTier={shopTier}
            currentModifiers={modifiers?.data}
          />
          <div className={styles.buttonsContainer}>
            <Button className={styles.buttonDark} onClick={handleCloseNewDialog}>
              {t('common.close')}
            </Button>
            <Button className={styles.buttonDark} onClick={handleAddNew} disabled={selectedMethod === -1}>
              {t('common.add')}
            </Button>
          </div>
        </div>
      </Dialog>
    </div>
  ) : !isTemplate ? (
    <div className={styles.mainPart}>
      <ProductTypeEditor
        selectedEdit={selectedEdit}
        setIsEdit={setIsEdit}
        setSelectedEdit={setSelectedEdit}
        deleteModifier={deleteModifier}
        createModifier={createModifier}
        updateModifier={updateModifier}
        createPrio2Modifier={createPrio2Modifier}
        updatePrio2Modifier={updatePrio2Modifier}
        edit={prio2Edit}
        setEdit={setPrio2Edit}
        handleSubmit={handleSubmit}
        onClose={resetForm}
        datagridData={datagridData}
        handleDialogSubmit={handleDialogSubmit}
        handleDialogClose={handleDialogClose}
        dialogOpen={dialogOpen}
        setDialogOpen={setDialogOpen}
        prio2Modifiers={prio2Modifiers}
      />
    </div>
  ) : null;
};

export default TemplateMain;
